import React, { useState } from 'react';
import Editor from 'react-simple-code-editor';
import Prism from 'prismjs';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-python';
import 'prismjs/themes/prism-tomorrow.css';

const CodeInput = ({ onchange_python_expression , python_expression }) => {
  const [code, setCode] = useState('// Start typing your code...');

  return (
    <Editor
      value={python_expression}
      onValueChange={onchange_python_expression}
      highlight={(code) =>
        // Prism.highlight(code, Prism.languages.javascript, 'javascript')
        Prism.highlight(code, Prism.languages.python, 'python')
      }
      padding={10}
      style={{
        fontFamily: '"Fira code", "Fira Mono", monospace',
        fontSize: 10,
        backgroundColor: '#fff',
        color: '#000',
        borderRadius: '5px',
        minHeight: '50px',
        maxWidth: '165px',
        border: '1px solid #ddd',
      }}
    />
  );
};

export default CodeInput;